import styles from "./TransactionCategory.module.scss";
import clsx from "clsx";
import React from "react";

export const TransactionCategory = ({category, iconSize = 20}) => {
  const [background, color] = category.color.split("|");

  return <div className={clsx(styles.category, styles["size" + iconSize])}>
    <div className={styles.categoryColor} style={{background}}>
      <span className={clsx(styles.categoryIcon, "material-icons")} style={{color}}>{category.icon}</span>
    </div>

    <div className={styles.categoryName}>{category.groupName} / {category.name}</div>
  </div>;
};
